/**
 * @typedef {Object} IncorrectMatchResponseDto
 * @property {number} incorrectMatchId
 * @property {'rel'|'gastos'|'pagos'} conciliationType
 * @property {string} conciliationKey
 * @property {string} leftMatchKey
 * @property {string} rightMatchKey
 * @property {string|null} reason
 * @property {string|null} markedBy
 * @property {string} createdAtUtc
 */

/**
 * Shared fields returned by reconciliation row endpoints.
 * @typedef {Object} ReconciliationMatchRowDto
 * @property {string} conciliationKey
 * @property {string=} estadoConcilia
 * @property {boolean} isIncorrectMatch
 */

export const valueFrom = (row, keys = []) => {
  for (const key of keys) {
    const value = row?.[key];
    if (value !== undefined && value !== null && value !== '') return value;
  }
  return null;
};

export const getConciliationKey = (row) => valueFrom(row, ['conciliationKey', 'ConciliationKey']);

export const isIncorrectMatch = (row) => {
  const value = valueFrom(row, ['isIncorrectMatch', 'IsIncorrectMatch']);
  return value === true || (typeof value === 'string' && value.toLowerCase() === 'true');
};

export const isReconciliationMatch = (row) => {
  const status = valueFrom(row, ['estadoConcilia', 'EstadoConcilia', 'status', 'Status']);
  return String(status ?? '').trim().toLowerCase() === 'match';
};

export const incorrectMatchErrorMessage = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;
  const validationMessage = typeof data === 'string'
    ? data
    : data?.message ?? data?.title ?? Object.values(data?.errors ?? {}).flat().join(' ');

  if (status === 400) return validationMessage || 'The request is invalid. Review the reason and try again.';
  if (status === 404) return 'The reconciliation record no longer exists. Refresh the data and try again.';
  return 'The association could not be marked as incorrect. Please try again.';
};
